export default "__VITE_ASSET__Cjgcjn09__"